import { GitPullRequest, Circle } from "react-feather"

export default [
    {
        id: "complaint",
        title: "Өргөдөл, санал хүсэлт",
        icon: <GitPullRequest size={20} />,
        navLink: "complaint",
        children: [
            {
                id: 'complaint1',
                title: 'Өргөдөл',
                icon: <Circle size={8} />,
                navLink: "complaint/register"
            },
            // {
            //     id: 'complaint2',
            //     title: 'Дүнгийн дүйцүүлэлт',
            //     icon: <Circle size={8} />,
            //     navLink: "complaint/correspond"
            // },
            {
                id: 'complaint3',
                title: 'Чөлөөний хүсэлт',
                icon: <Circle size={8} />,
                navLink: "complaint/leave"
            },
            {
                id: 'complaint4',
                title: 'Тойрох хуудас',
                icon: <Circle size={8} />,
                navLink: "complaint/routing"
            },
        ]
    },
]
